import React from "react";
import _ from "lodash";
import FirestoreDocEditor from "../../components/FirestoreDocEditor";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  const projectId = _.get(ownProps, "projectId");
  const project = _.get(state, ["entities", "projects", "entities", projectId]);
  return {
    // medias: _.get(state, ['projects', projectId, 'medias']),
    project,
  };
};

const sanitizeToNumber = (value) => {
  const numberValue = _.toNumber(value);
  if (_.isNaN(numberValue)) return "N/A";
  return numberValue;
};

export default connect(mapStateToProps)(
  class extends React.Component {
    render() {
      const { projectId, project, docRef } = this.props;
      // console.log('Detail', project);
      return (
        <FirestoreDocEditor
          {...this.props}
          mediaEngine="firebase"
          mediaEngineConfig={{
            storagePath: `medias/projects/${projectId}`,
            firestorePath: `medias`,
          }}
          id={projectId}
          data={project}
          docRef={docRef}
          mapDocDataToFields={(data, id) => ({
            title: {
              label: "Title",
              value: _.get(data, "title.en", _.get(data, "title", "")),
              placeholder: "Project name",
            },
            titleTH: {
              label: "Title (ไทย)",
              value: _.get(data, "title.th", ""),
              placeholder: "ชื่อโครงการ",
            },
            // station: {
            //   label: "Station Code",
            //   value: _.get(data, "station", ""),
            //   placeholder: "BL01",
            // },
            lat: {
              label: "Lat",
              value: _.get(data, "location.position._lat", 13.747512),
              placeholder: "Ex. 13.747512",
            },
            lon: {
              label: "Lon",
              value: _.get(data, "location.position._long", 100.534616),
              placeholder: "Ex. 100.534616",
            },
            yearLaunch: {
              label: "Year Open",
              value: _.get(data, "yearLaunch", ""),
              placeholder: "Ex. 2019",
            },
            yearComplete: {
              label: "Year Complete",
              value: _.get(data, "yearComplete", ""),
              placeholder: "Ex. 2020",
            },

            developer: {
              label: "Developer",
              value: _.get(data, "developer", ""),
              placeholder: "Ex. Sansiri",
            },
            distanceFromBts: {
              label: "Distance to Bts",
              value: _.get(data, "distanceFromBts", ""),
              placeholder: "Ex. 200",
            },
            parkingLot: {
              label: "Parking Lot",
              value: _.get(data, "parkingLot", ""),
              placeholder: "Ex. 60 (in percent)",
            },
            projectType: {
              label: "Project Type",
              value: _.get(data, "projectType", ""),
              placeholder: "Ex. Low Rise / High Rise",
            },
            floor: {
              label: "Floor",
              value: _.get(data, "floor", ""),
              placeholder: "Ex. 8",
            },
            furniturePackage: {
              label: "Furniture Package",
              value: _.get(data, "furniturePackage", ""),
              placeholder: "Ex. Fully Furnished / Fully Fitted / n/a",
            },
            ceiling: {
              label: "Ceiling",
              value: _.get(data, "ceiling", ""),
              placeholder: "Ex. 2.5 / n/a",
            },
            sinkingFund: {
              label: "Sinking Fund",
              value: _.get(data, "sinkingFund", ""),
              placeholder: "Ex. 500 / n/a",
            },
            commonFee: {
              label: "Common Fee",
              value: _.get(data, "commonFee", ""),
              placeholder: "Ex. 42 / n/a",
            },
            projectStatus: {
              label: "Project Status",
              value: _.get(data, "projectStatus", ""),
              placeholder: "Ex. Sold Out / On-Sale",
            },
            constructionStatus: {
              label: "Construction Status",
              value: _.get(data, "constructionStatus", ""),
              placeholder: "Ex. RTM / Under Construction / On Hold / Cancel",
            },
            absorptionRateAll: {
              label: "Absorption Rate / Quarter",
              value: _.get(data, "absorptionRateAll", ""),
              placeholder: "Ex. 0.0124277101 / Sold Out",
            },
            absorptionRateLastQ: {
              label: "Absorption Rate Last Quarter",
              value: _.get(data, "absorptionRateLastQ", ""),
              placeholder: "Ex. 0.006644518272 / Sold Out",
            },
            theAgentStock: {
              label: "Stock",
              value: _.get(data, "stock", 0),
            },
            theAgentProjectId: {
              label: "ProjectID",
              value: _.get(data, "integrations.TheAgent.ProjectID", ""),
              placeholder: 1,
            },
            theAgentProjectCode: {
              label: "ProjectCode",
              value: _.get(data, "integrations.TheAgent.ProjectCode", ""),
            },
            theAgentProjectLink: {
              label: "Link",
              value: _.get(data, "integrations.TheAgent.ProjectLink", ""),
              placeholder: "https://www.theagent.co.th/project/d/6/",
            },
            // Stats
            // salePrice: {
            //   label: "Sale Price",
            //   value: _.get(data, "resalePriceSqm", "N/A"),
            //   placeholder: 1000000,
            // },
            // rentalPrice: {
            //   label: "Rent Price",
            //   value: _.get(data, "rentalPriceSqm", "N/A"),
            //   placeholder: 100,
            // },
            // startingPrice: {
            //   label: "Starting Price",
            //   value: _.get(data, "startingPrice", "N/A"),
            //   placeholder: "Ex. 3.9 (in million baht)",
            // },
            startingCurrentPrice: {
              label: "Starting Current Package (Project)",
              value: _.get(data, "startingCurrentPrice", "N/A"),
              placeholder: "Ex. 1.99 (in million baht)",
            },
            rentalPrice: {
              label: "Rent Price",
              value: _.get(data, "rentalPrice", "N/A"),
              placeholder: "Ex. 8920.00",
            },
            currentPriceSqm: {
              label: "Current Price / sq.m.",
              value: _.get(data, "currentPriceSqm", "N/A"),
              placeholder: "Ex. 33858.78",
            },
            launchPriceSqm: {
              label: "Average of Launch Price",
              value: _.get(data, "launchPriceSqm", ""),
              placeholder: "Ex. 28677.42",
            },
            // capitalGain: {
            //   label: "Capital Gain",
            //   value: _.get(data, "capitalGain", "N/A"),
            //   placeholder: 0.01,
            // },
            // rentalYield: {
            //   label: "Rental Yield",
            //   value: _.get(data, "rentalYield", "N/A"),
            //   placeholder: 0.01,
            // },
          })}
          mapFieldValuesToDocData={(fieldValues) => {
            // console.log('mapFieldValuesToDocData', fieldValues)
            return {
              title: {
                en: fieldValues.title,
                th: fieldValues.titleTH,
              },
              location: {
                position: {
                  _lat: _.toNumber(fieldValues.lat),
                  _long: _.toNumber(fieldValues.lon),
                },
              },
              station: !_.isEmpty(fieldValues.station)
                ? fieldValues.station
                : "X",
              // current: {
              //   salePrice: sanitizeToNumber(fieldValues.salePrice), // !_.isEmpty(fieldValues.salePrice) ? Number(fieldValues.salePrice) : 'N/A',
              //   rentalPrice: sanitizeToNumber(fieldValues.rentalPrice), // !_.isEmpty(fieldValues.rentalPrice) ? Number(fieldValues.rentalPrice) : 'N/A',
              //   capitalGain: sanitizeToNumber(fieldValues.capitalGain), // !_.isEmpty(fieldValues.capitalGain) ? Number(fieldValues.capitalGain) : 'N/A',
              //   rentalYield: sanitizeToNumber(fieldValues.rentalYield), // !_.isEmpty(fieldValues.rentalYield) ? Number(fieldValues.salePrice) : 'N/A',
              // },

              yearLaunch: fieldValues.yearLaunch,
              yearComplete: fieldValues.yearComplete,

              developer: fieldValues.developer,
              distanceFromBts: sanitizeToNumber(fieldValues.distanceFromBts),
              parkingLot: sanitizeToNumber(fieldValues.parkingLot),
              projectType: fieldValues.projectType,
              floor: sanitizeToNumber(fieldValues.floor),
              furniturePackage: fieldValues.furniturePackage,
              ceiling: sanitizeToNumber(fieldValues.ceiling),
              sinkingFund: sanitizeToNumber(fieldValues.sinkingFund),
              commonFee: sanitizeToNumber(fieldValues.commonFee),
              projectStatus: fieldValues.projectStatus,
              constructionStatus: fieldValues.constructionStatus,
              absorptionRateAll: fieldValues.absorptionRateAll,
              absorptionRateLastQ: fieldValues.absorptionRateLastQ,
              integrations: {
                TheAgent: {
                  ProjectID: fieldValues.theAgentProjectId,
                  ProjectCode: fieldValues.theAgentProjectCode,
                  ProjectLink: fieldValues.theAgentProjectLink,
                },
              },
              // startingPrice: sanitizeToNumber(fieldValues.startingPrice), //!_.isEmpty(fieldValues.startingPrice) ? Number(fieldValues.startingPrice) : 'N/A',
              startingCurrentPrice: sanitizeToNumber(
                fieldValues.startingCurrentPrice
              ),
              rentalPrice: sanitizeToNumber(fieldValues.rentalPrice),
              currentPriceSqm: sanitizeToNumber(fieldValues.currentPriceSqm),
              launchPriceSqm: sanitizeToNumber(fieldValues.launchPriceSqm),

              // capitalGain: sanitizeToNumber(fieldValues.capitalGain),
              // rentalYield: sanitizeToNumber(fieldValues.rentalYield),
              stock: !_.isEmpty(fieldValues.theAgentStock)
                ? fieldValues.theAgentStock
                : 0,
            };
          }}
          sections={[
            {
              title: "Info",
              fields: [
                "title",
                "titleTH",
                "station",
                "yearLaunch",
                "yearComplete",
                "developer",
                "distanceFromBts",
                "parkingLot",
                "projectType",
                "floor",
                "furniturePackage",
                "ceiling",
                "sinkingFund",
                "commonFee",
                "projectStatus",
                "constructionStatus",
                "absorptionRateAll",
                "absorptionRateLastQ",
              ],
            },
            {
              title: "Stats",
              fields: [
                // "salePrice",
                // "rentalPrice",
                // "startingPrice",
                // "currentPriceSqm",
                "startingCurrentPrice",
                "rentalPrice",
                "currentPriceSqm",
                "launchPriceSqm",
                // "capitalGain",
                // "rentalYield",
              ],
            },
            {
              title: "Location",
              fields: ["lat", "lon"],
            },
            {
              title: "Integration with TheAgent",
              fields: [
                "theAgentProjectId",
                "theAgentProjectCode",
                "theAgentProjectLink",
                "theAgentStock",
              ],
            },
          ]}
        />
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/admin/screens/Project/detail.js